import React from 'react';
import Table from '../../components/table';

interface TableColumn {
  label: string;
  accessor: string;
  render?: (value: any) => React.ReactNode;
  sortable?: boolean;
  minWidth?: string;
}

interface JobsiteListViewProps {
  tableData: any[];
  columns: TableColumn[];
  totalItems: number;
  currentPage: number;
  pageSize: number;
  sortConfig: { key: string; direction: 'asc' | 'desc' | null };
  onPageChange: (page: number) => void;
  onSort: (key: string, direction: 'asc' | 'desc' | null) => void;
  onRowClick?: (item: any) => void;
}

const JobsiteListView: React.FC<JobsiteListViewProps> = ({
  tableData,
  columns,
  totalItems,
  currentPage,
  pageSize,
  sortConfig,
  onPageChange,
  onSort,
  onRowClick,
}) => {
  if (tableData.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 px-4">
        <svg className="w-16 h-16 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
          />
        </svg>
        <h3 className="text-lg font-medium text-gray-900 mb-1">No Results Found</h3>
        <p className="text-sm text-gray-500 text-center max-w-md">No jobsites match your search criteria</p>
      </div>
    );
  }

  return (
    <Table
      columns={columns}
      data={tableData}
      totalItems={totalItems}
      currentPage={currentPage}
      pageSize={pageSize}
      onPageChange={onPageChange}
      onSort={onSort}
      sortConfig={sortConfig}
      onRowClick={onRowClick}
      makeRowClickable={true}
    />
  );
};

export default JobsiteListView; 